var _line, _path, _path2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 238,
    viewBox: "0 0 48 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 24.5,
    y1: 2.18557e-8,
    x2: 24.5,
    y2: 80,
    stroke: "#64748B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 119V139.572H20.5715V119H6.85719C6.85719 111.438 13.0096 105.286 20.5715 105.286V98.4287C9.22767 98.4287 0 107.656 0 119Z",
    fill: "#036C5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 105.286V98.4287C36.6554 98.4287 27.4277 107.656 27.4277 119V139.572H47.9992V119H34.2849C34.2849 111.438 40.4373 105.286 47.9992 105.286Z",
    fill: "#036C5F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 24.5,
    y1: 158,
    x2: 24.5,
    y2: 238,
    stroke: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.719b0ae82e2c5cbda7e0ca8fb3d9e915.svg";
export { ForwardRef as ReactComponent };